(function() {
    window.c24.lp.ac.hub = {

        init: function() {
            const options = [
                'A',
                'B',
                'C',
            ];

            options.forEach(function(option) {
                $('.mod24ac.hub .option' + option).on('click', function() {
                    const ac = $(this).closest('.mod24ac');
                    const radio = $('.option' + option + ' input[type=radio]', ac);
                    const url = radio.attr('data-url');
                    const input = $('[id*=birthdate]');
                    const birthdateValue = $('[id*=option' + option + 'Birthdate]', ac).val();
                    const birthdateName = $('[id*=option' + option + 'Birthdate]', ac).attr('name');

                    input.attr('name', birthdateName);
                    input.attr('value', birthdateValue);
                    input.attr('class', 'c24' + option);

                    if ($('.c24' + option).length === 0) {
                        $('.box24Form.box24FormHub fieldset').append(input);
                    }

                    $('.box24FormHub', ac).attr('action', url);

                    options.forEach(function(otherOption) {
                        if (option != otherOption) {
                            $('.option' + otherOption, ac).removeClass('selected');
                            $('.c24' + otherOption, ac).remove();
                        }
                    });

                    $('.c24ErrorMsg', ac).css('display', 'none');
                    $('.option' + option, ac).addClass('selected');

                    radio.prop('checked', true);
                });
            });

            $('.mod24ac.hub .c24Button').on('click', function() {
                const ac = $(this).closest('.mod24ac');
                if ($('.box24FormHub', ac).attr('action') === '#') {
                    $('.c24ErrorMsg', ac).css('display', 'block');
                    $('html').stop().animate({
                        'scrollTop': 0,
                    });
                }
            });

            $('.mod24ac.hub .box24FormHub').on('submit', function(e) {
                const ac = $(this).closest('.mod24ac');
                const oElement = $(this).find('.js24LoadingAction');
                if ($('.box24FormHub', ac).attr('action') === '#') {
                    e.preventDefault();
                    oElement.removeClass('is-loading');
                }
                options.forEach(function(option) {
                    $('[id*=option' + option + 'Birthdate]', ac).remove();
                });

                if ($('.box24FormHub', ac).attr('action').indexOf('.bu.check24') >= 0 ) {
                    if ($('input[name=splash]', ac).length < 1) {
                        $('.box24FormHub fieldset', ac).append('<input type="hidden" value="0" name="splash" />');
                    }
                } else {
                    $('input[name=splash]', ac).remove();
                }
            });
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.hub.init();
    });
})();
